import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../global/Button';
import warningIcon from '../../assets/icons/DashboardIcons/warning.svg';

const RegisterBusinessCard = () => {
  const navigate = useNavigate();

  const navigateTo = () => {
    navigate(`/my-business`, {});
  };
  return (
    <div className='bg-[#f8b40033] pb-[13px] pt-[7px] md:bg-[#F8B40026] rounded-sm leading-[22px]  border-[#DDDD] md:py-[7px] !px-4 '>
      <div className='flex-cols md:flex justify-between items-center '>
        <div>
          <h4 className='text-[14px] font-poppins font-bold text-green md:text-[15px]'>
            <img src={warningIcon} alt='warn' className='mr-2 md:mt-2' />
            Register your business
          </h4>
          <p className='pt-[13px] text-[10px] pl-[0px] font-poppins md:pl-[32px] md:pt-[0px] font-normal leading-[18px] text-black md:text-xs'>
            Get your CAC Registration — business name or Limited Liability company registered by our
            reliable accredited CAC consultants.
          </p>
        </div>
        <div className='py-3'>
          <Button onClick={navigateTo} className='text-xs whitespace-nowrap px-1' size='sm'>
            REGISTER NOW
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RegisterBusinessCard;
